function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useMemo, memo } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { SearchInput } from '@cbhq/cds-web/controls/SearchInput';
import { Box } from '@cbhq/cds-web/layout';
import { deviceBreakpoints } from '@cbhq/cds-web/layout/breakpoints';
import { spacing } from '@cbhq/cds-web/tokens';
import { getLoggedOutConfigList, DEFAULT_LOCALE, getLoggedOutFallbackLocales } from '@cbhq/intl';
import '../GlobalNav/constants/index.js';
import { GLOBAL_EDITION_CODE } from '../GlobalPreferences/constants.js';
import LanguageSelectorCell from './LanguageSelectorCell.js';
import messages from './messages.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { MOBILE_BREAKPOINT } from '../GlobalNav/constants/constants.js';
const filterLocales = (locales, searchText) => {
  const lowercasedSearchText = searchText.toLowerCase();
  return locales.filter(language => language.name.toLowerCase().includes(lowercasedSearchText) || language.code.toLowerCase().includes(lowercasedSearchText));
};
function TrapdoorContentLanguageSelector({
  userLocaleInfo,
  localeInformation
}) {
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchText = _useState2[0],
    setSearchText = _useState2[1];
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const configList = useMemo(() => {
    const countryConfig = getLoggedOutConfigList();
    const countryList = [...countryConfig];
    const globalEdition = {
      country_code: GLOBAL_EDITION_CODE,
      country_name: formatMessage(messages.globalLabel),
      default_locale: DEFAULT_LOCALE,
      supported_locales: getFallbackLanguagesList(localeInformation)
    };
    if (searchText) {
      const lowercasedSearchText = searchText.toLowerCase();

      // filter countries by name and/or supported locales
      const filtered = countryList.filter(country => {
        const countryMatches = country.country_name.toLowerCase().includes(lowercasedSearchText);
        const matchingLocales = filterLocales(country.supported_locales, searchText);
        return countryMatches || matchingLocales.length > 0;
      });

      // filter supported locales so we don't show a language that doesn't match the search
      // this prevents searching for "English" and seeing both "English" and "Espanol" for US for example
      const supportedFiltered = filtered.map(country => {
        const countryMatches = country.country_name.toLowerCase().includes(lowercasedSearchText);
        return _objectSpread(_objectSpread({}, country), {}, {
          supported_locales: countryMatches ? country.supported_locales : filterLocales(country.supported_locales, searchText)
        });
      });

      // apply the same filtering to fallback locales
      const globalFiltered = _objectSpread(_objectSpread({}, globalEdition), {}, {
        supported_locales: filterLocales(globalEdition.supported_locales, searchText)
      });

      // only show fallback locales if there are any matches
      if (globalFiltered.supported_locales.length > 0) {
        supportedFiltered.push(globalFiltered);
      }
      return supportedFiltered;
    }
    return [...countryList, globalEdition];
  }, [formatMessage, localeInformation, searchText]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(SearchInputWrapper, {
      children: /*#__PURE__*/jsx(SearchInput, {
        compact: true,
        value: searchText,
        onChangeText: setSearchText,
        placeholder: formatMessage(messages.searchPlaceholder),
        startIconAccessibilityLabel: formatMessage(messages.searchA11yLabel),
        clearIconAccessibilityLabel: formatMessage(messages.clearA11yLabel)
      })
    }), /*#__PURE__*/jsx(ScrollContainer, {
      children: configList.map(country => {
        return country.supported_locales.map(language => {
          return /*#__PURE__*/jsx(LanguageSelectorCell, {
            language: language,
            countryConfig: country,
            localeInformation: localeInformation,
            userLocaleInfo: userLocaleInfo
          }, language.code);
        });
      })
    })]
  });
}
const ScrollContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-y: scroll;
`;
const SearchInputWrapper = styled(Box)`
  padding: ${spacing[4]} ${spacing[3]} ${spacing[3]} ${spacing[4]};

  @media (max-width: ${deviceBreakpoints.tablet}px) {
    padding: ${spacing[3]};
  }

  @media screen and (min-width: ${MOBILE_BREAKPOINT}px) {
    padding: 0px 0px ${spacing[2]};
  }
`;
function getFallbackLanguagesList(localeInformation) {
  // The "Global" entry should have all the fallback language
  // ie. regions not part of loc-2.0 + English
  //
  // why English? For the case where user landing on coinbase.com/ from India

  return [DEFAULT_LOCALE, ...getLoggedOutFallbackLocales()].map(locale => {
    return {
      tag: locale,
      name: localeInformation.localeCodeToDisplayName[locale],
      code: locale
    };
  });
}
const LanguageSelector = /*#__PURE__*/memo(TrapdoorContentLanguageSelector);
export { LanguageSelector as default, getFallbackLanguagesList };
//# sourceMappingURL=LanguageSelector.js.map
